import { EMPTY_APPRAISAL_FILTERS, formatStatusLabel } from "./appraisalListQuery";

/** Maps appraisal filter keys to URL query parameter names. */
export const APPRAISAL_FILTER_URL_CONFIG = {
  paramMap: {
    campaign: "campaign",
    designation: "designation",
    department: "department",
    month: "month",
    quarter: "quarter",
    pafStatus: "status",
    supervisor: "supervisor",
  },
  reservedParams: ["q", "sortBy", "sortDir", "id"],
};

export function getAppraisalModuleKey(pathname, baseFilters = null) {
  const listSource = String(baseFilters?.listSource || "").toLowerCase();
  const engineSuffix = listSource === "engine" ? "-engine" : "";

  if (pathname.startsWith("/quarterly-appraisal")) {
    return `quarterly-appraisals${engineSuffix}`;
  }
  if (pathname.startsWith("/yearly-appraisals")) {
    return `yearly-appraisals${engineSuffix}`;
  }
  if (
    pathname.startsWith("/probational-appraisals") ||
    pathname.startsWith("/probationary-appraisals")
  ) {
    return "probation-appraisals";
  }
  if (pathname.startsWith("/monthly-reports")) {
    return "monthly-reports";
  }

  const frequency = String(baseFilters?.frequency || "").toLowerCase();
  if (frequency === "quarterly") return `quarterly-appraisals${engineSuffix}`;
  if (frequency === "yearly") return `yearly-appraisals${engineSuffix}`;
  if (frequency === "probationary" || frequency === "probational") {
    return "probation-appraisals";
  }

  return "monthly-appraisals";
}

export function appraisalFiltersToPersistent(appraisalFilters) {
  if (!appraisalFilters) {
    return {};
  }

  const next = {};

  Object.entries(appraisalFilters).forEach(([key, entry]) => {
    const value = entry?.value ?? entry;
    if (value === null || value === undefined || value === "") {
      return;
    }
    next[key] = value;
  });

  return next;
}

export function persistentToAppraisalFilters(flatFilters, labelResolver = {}) {
  const next = { ...EMPTY_APPRAISAL_FILTERS };

  const assign = (key, formatLabel) => {
    const raw = flatFilters?.[key];
    if (raw === null || raw === undefined || raw === "") {
      return;
    }

    const label =
      (typeof labelResolver[key] === "function" ? labelResolver[key](raw) : null) ||
      (typeof formatLabel === "function" ? formatLabel(raw) : String(raw));

    next[key] = { value: raw, label };
  };

  assign("campaign");
  assign("designation");
  assign("department");
  assign("month");
  assign("quarter");
  assign("pafStatus", formatStatusLabel);
  assign("supervisor");

  return next;
}

export function hasPersistentAppraisalFilters(flatFilters) {
  return Object.values(flatFilters || {}).some(
    (value) => value !== null && value !== undefined && value !== ""
  );
}
